import React from 'react'
import DialogoIngresarSinCupo from './DialogoIngresarSinCupo'

function SinCupoIngresarPorCereal (props) {
  const { cerealFiltradoNombre, ingresarPorCereal } = props

  const mensajeConfirmacion = `Si confirma van a ingresar todos los camiones de ${cerealFiltradoNombre} que se encuentran sin cupo. ¿Quiere continuar?`
  const buttonText = `Ingresar camiones de ${cerealFiltradoNombre}`

  return (
    <DialogoIngresarSinCupo
      ingresar={ingresarPorCereal}
      titulo='Ingreso de camiones sin cupo'
      buttonText={buttonText}
      mensajeConfirmacion={mensajeConfirmacion}
    />
  )
}

export default SinCupoIngresarPorCereal
